import React, { useState, useEffect, useRef } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import {
  Typography,
  Popper,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  FormControl,
  Button,
  Paper,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  MenuItem,
} from "@mui/material";

const TableToolbar = (props) => {
  const {
    handleFilterChange,
    customRange,
    setCustomRange,
    selectedValue,
    setSelectedValue,
    setTimeFilter,
    value,
    setValue,
    allOrNewUsers,
    setAllOrNewUsers,
  } = props;

  const superLogoutHandler = () => {
    localStorage.removeItem("superToken");
    window.location.href = "/superlogin";
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [showCustomRange, setShowCustomRange] = useState(false);

  const popperRef = useRef(null); // To track the popper element

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    handleFilterChange();
    if (value === "custom range") {
      setShowCustomRange(true);
    } else {
      setShowCustomRange(false);
    }
  };

  const handleCustomRangeChange = (field, value) => {
    setCustomRange({
      ...customRange,
      [field]: value,
    });
  };

  const handleApply = () => {
    setAnchorEl(null); // Close the Popper
    setTimeFilter(selectedValue); // <-- Update timeFilter in parent
  };

  const handleClickOutside = (event) => {
    if (
      popperRef.current &&
      !popperRef.current.contains(event.target) &&
      anchorEl &&
      !anchorEl.contains(event.target)
    ) {
      setAnchorEl(null); // Close the Popper when clicking outside of it
    }
  };

  useEffect(() => {
    if (anchorEl) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);

  const open = Boolean(anchorEl);
  const id = open ? "time-filter-popper" : undefined;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={value}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            handleChange(null, newValue);
          }
        }}
      >
        <ToggleButton
          value="visitors"
          sx={{ padding: "0 1.5rem", textTransform: "none" }}
        >
          Aadhar eSign
        </ToggleButton>
        <ToggleButton
          value="visitors_digital_signatures_info"
          sx={{ padding: "0.5rem 1.5rem", textTransform: "none" }}
        >
          Digital Signature
        </ToggleButton>
      </ToggleButtonGroup>

      <Box sx={{ display: "flex" }}>
        <Select
          sx={{ mr: 2 }}
          size="small"
          value={allOrNewUsers}
          label=""
          onChange={(e) => setAllOrNewUsers(e.target.value)}
        >
          <MenuItem value={"allUsers"}>All User(s)</MenuItem>
          <MenuItem value={"newUsers"}>New User(s)</MenuItem>
        </Select>

        <Button
          aria-describedby={id}
          variant="outlined"
          onClick={handleClick}
          startIcon={<FilterListIcon />}
          sx={{
            width: "100%",
            textTransform: "capitalize",
            minWidth: 150,
            mr: 2,
          }}
        >
          {selectedValue}
        </Button>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          sx={{ zIndex: 99 }}
        >
          <Paper
            sx={{
              padding: "1rem",
              backgroundColor: "white",
              boxShadow: 3,
              display: "flex",
              flexDirection: "column",
              minWidth: "250px",
            }}
            ref={popperRef}
          >
            <FormControl component="fieldset">
              <RadioGroup value={selectedValue} onChange={handleRadioChange}>
                <FormControlLabel
                  value="today"
                  control={<Radio />}
                  label="Today"
                />
                <FormControlLabel
                  value="yesterday"
                  control={<Radio />}
                  label="Yesterday"
                />
                <FormControlLabel
                  value="this week"
                  control={<Radio />}
                  label="This week"
                />
                <FormControlLabel
                  value="this month"
                  control={<Radio />}
                  label="This month"
                />
                <FormControlLabel
                  value="custom range"
                  control={<Radio />}
                  label="Custom Range"
                />
              </RadioGroup>
              {showCustomRange && (
                <div>
                  <TextField
                    size="small"
                    label="Start Date"
                    type="date"
                    value={customRange.start}
                    onChange={(e) =>
                      handleCustomRangeChange("start", e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                    sx={{ marginTop: "1rem", marginRight: "0.5rem" }}
                  />
                  <TextField
                    size="small"
                    label="End Date"
                    type="date"
                    value={customRange.end}
                    onChange={(e) =>
                      handleCustomRangeChange("end", e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                    sx={{ marginTop: "1rem" }}
                  />
                </div>
              )}
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              onClick={handleApply}
              sx={{ marginTop: "0.5rem" }}
            >
              Apply
            </Button>
          </Paper>
        </Popper>

        <Button
          variant="outlined"
          color="error"
          startIcon={<LogoutOutlinedIcon />}
          onClick={superLogoutHandler}
          sx={{ minWidth: 120, textTransform: "none" }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default TableToolbar;
